<template>
  <validationObserver
    ref="taxForm"
    v-slot="{ handleSubmit }"
    slim
  >
    <b-card
      v-can="'create-tax'"
    >
      <b-overlay
        :show="loading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <b-form
          ref="taxForm"
          @submit.prevent="handleSubmit(updateOrderCancelSetting)"
        >
          <!-- Start of : Order Cancellation   -->
          <b-row>
            <b-card title="Order Cancellation Option">
              <b-form-radio-group
                v-model="form.enabled"
                :options="orderCancelOptions"
                value-field="item"
                text-field="name"
                disabled-field="disabled"
                @change="updateOrderCancelSetting()"
              />
            </b-card>
          </b-row>
          <b-row>
            <div class="ml-2">
              Enable or disable the auto order cancellation feature.
            </div>
          </b-row>
          <b-row v-if="form.enabled">
            <b-card title="Create New Cancellation Condition">
              <div>
                <div>
                  <b-row>
                    <b-col md="6">
                      <validation-provider
                        name="Order Status"
                        rules="required"
                      >
                        <label for="name">Order Status</label>
                        <b-form-input
                          :value="form.status_key === 'key_2' ? 'CONFIRMED' : form.status_key"
                          readonly
                        />
                      </validation-provider>
                    </b-col>
                    <b-col md="6">
                      <validation-provider
                        #default="{ errors }"
                        name="Cancel After"
                        rules="required"
                      >
                        <label for="name">Cancel After</label>
                        <b-form-input
                          v-model="form.interval_value"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                    <b-col md="6">
                      <validation-provider
                        #default="{ errors }"
                        name="Duration Unit"
                        rules="required"
                      >
                        <label for="name">Duration Unit</label>
                        <v-select
                          v-model="form.interval_type"
                          :options="intervalTypes"
                          :state="errors.length > 0 ? false : null"
                          :reduce="opt => opt.value"
                          placeholder="Select Duration Type"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-card>
          </b-row>
          <b-row v-if="form.enabled">
            <!-- submit -->
            <b-col class="d-flex justify-content-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                class="mt-1 custom-button-color"
              >
                Submit
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-overlay>
    </b-card>
  </validationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BForm, BButton, BCard, BOverlay, BFormRadioGroup, BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import vSelect from 'vue-select'

const autoOrderCancelSettingRepository = RepositoryFactory.get('autoOrderCancelSetting')
export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BCard,
    BOverlay,
    BFormRadioGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      loading: false,
      form: {
        enabled: null,
        status_key: '',
        interval_type: '',
        interval_value: null,
        target_status_key: '',
      },
      intervalTypes: [
        { label: 'Days', value: 'days' },
        { label: 'Months', value: 'months' },
        { label: 'Years', value: 'years' },
      ],
      orderCancelOptions: [
        { item: true, name: 'On' },
        { item: false, name: 'Off' },
      ],
    }
  },
  mounted() {
    this.readOrderCancelSetting()
  },
  methods: {
    async readOrderCancelSetting() {
      try {
        this.loading = true
        const res = await autoOrderCancelSettingRepository.getOrderCancelSetting()
        const data = res?.data?.data ?? res?.data ?? {}
        this.form = {
          enabled: Boolean(data.enabled),
          status_key: data.status_key || '',
          interval_type: data.interval_type || '',
          interval_value: data.interval_value ?? null,
          target_status_key: data.target_status_key || '',
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.loading = false
      }
    },
    async updateOrderCancelSetting() {
      try {
        const res = await autoOrderCancelSettingRepository.updateOrderCancelSetting(this.form)
        if (res.status === 200) {
          this.showSuccessMessage('Order Cancellation Settings Updated Successfully')
        } else {
          this.showErrorMessage('Cannot Update Order Cancellation Settings')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
}
</script>
<style scoped lang="scss">
.set_right {
    float: right;
}

.custom-button-color {
    background-color: #4186f5 !important;
    border-color: #4186f5 !important;
}
</style>
